module.exports = __webpack_public_path__ + "img/charis-presets_thumbnail.d4996080.jpg";